var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: { isOpen: _vm.isOpen },
      on: { "update:isOpen": _vm.handleUpdateIsOpen }
    },
    [
      _c(
        "div",
        { staticClass: "ep-error-dialog" },
        [
          _c("ExclamationCircle", { staticClass: "error-icon" }),
          _c(
            "div",
            {
              staticClass: "title text-center",
              attrs: { "data-testid": "title" }
            },
            [_vm._v(_vm._s(_vm.title))]
          ),
          _c(
            "div",
            {
              staticClass: "description",
              attrs: { "data-testid": "description" }
            },
            [_vm._v(_vm._s(_vm.description))]
          ),
          _c(
            "EpButton",
            {
              staticClass: "confirm-button",
              on: { click: _vm.handleConfirmButtonClick }
            },
            [_vm._v("OK")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }